import React from "react";
import showIcon from "../../../../../assets/design-revamp-company/company-detail-headers/icon-show-table.svg";
import hideIcon from "../../../../../assets/design-revamp-company/company-detail-headers/icon-hide-table.svg";

export const ShowHide = ({ show, setShow }) => {
  return (
    <img
      src={show ? hideIcon : showIcon}
      alt={show ? "Hide Icon" : "Show Icon"}
      width={40}
      height={40}
      onClick={() => setShow(!show)}
      className="show-hide-icon"
    />
  );
};
